// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorBoundary__error___3fGXU","stack":"ErrorBoundary__stack___18Rfa"};